module.exports = __webpack_public_path__ + "img/RS_ (2).c33b7c1a.png";